import React, { useEffect, useRef, useState } from "react";
import { CSVLink } from "react-csv";
import SearchBox from "../../Common/SearchBox";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import ActiveAttorney from "./ActiveAttorney";
import ArchivedAttorney from "./ArchivedAttorney";
import { GetProfessionalServiceListing } from "../../../redux/features/AttorneyService";
import moment from "moment-timezone";
import ModalCustom from "../../Common/ModalCustom";
import AddAttorney from "./Create/AddAttorney";
import Loader from "../../Common/Loader";

const Attorney = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(0);
  const tabs = ["Active", "Inactive"];
  const { getCombinedListing } = useSelector((state) => state.attorney);
  const [csvData, setCsvData] = useState([]);
  const [search, setSearch] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [isCsvDataShow, setCsvDataShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filteredData, setFilteredData] = useState(null);

  const handleSearch = (searchText) => {
    setSearch(searchText);
  };

  const csvLink = useRef();
  const handleCsvDownload = async () => {
    try {
      setLoading(true);
      // Fetch both attorney and fiduciary data for CSV
      const [attorneyResponse, fiduciaryResponse] = await Promise.all([
        dispatch(GetProfessionalServiceListing({
          search: search,
          role: 3,
          csv: true,
          status: activeTab === 1 ? "0" : "1",
        })),
        dispatch(GetProfessionalServiceListing({
          search: search,
          role: 6,
          csv: true,
          status: activeTab === 1 ? "0" : "1",
        }))
      ]);

      // Combine both responses
      const combinedData = [
        ...(attorneyResponse?.payload?.data || []),
        ...(fiduciaryResponse?.payload?.data || [])
      ];

      const appendedData = _.map(combinedData, (data) => {
        return {
          firstName: data.firstName,
          lastName: data.lastName,
          email: data.email,
          phoneNumber: data.phoneNumber,
          serviceType: data.role === 6 ? 'Fiduciary' : 'Attorney',
          createdAt: moment(data.createdAt).format("MM/DD/yyyy @ HH:mm PT"),
          updatedAt: moment(data.updatedAt).format("MM/DD/yyyy @ HH:mm PT"),
        };
      });
      if (Array.isArray(appendedData)) {
        const sortedData = _.sortBy(appendedData, "firstName");
        setCsvData(sortedData);
        setCsvDataShow(true);
      } else {
        console.error("Invalid data format for CSV export");
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (csvData?.length > 0 && isCsvDataShow) {
      csvLink.current.link.click();
      setCsvDataShow(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [csvData]);

  const headers = [
    { label: "First Name", key: `firstName` },
    { label: "Last Name", key: `lastName` },
    { label: "Email", key: "email" },
    { label: "Phone Number", key: "phoneNumber" },
    { label: "Service Type", key: "serviceType" },
    { label: "Last Session", key: "createdAt" },
    { label: "Last Updated", key: "updatedAt" },
  ];

  useEffect(() => {
    if (search.trim() === "") {
      setFilteredData(getCombinedListing?.data);
    } else {
      const filtered = _.filter(
        getCombinedListing?.data,
        (item) =>
          item?.firstName
            ?.trim()
            .toLowerCase()
            .includes(search.trim().toLowerCase()) ||
          item?.lastName
            ?.trim()
            .toLowerCase()
            .includes(search.trim().toLowerCase()) ||
          (item?.email && // NOSONAR
            item?.email
              .trim()
              .toLowerCase()
              .includes(search.trim().toLowerCase())) ||
          (item?.phoneNumber && // NOSONAR
            item?.phoneNumber.trim().includes(search.trim()))
      );

      setFilteredData(filtered);
    }
  }, [search, getCombinedListing]);

  return (
    <>
      {loading && <Loader />}
      <div className="w-100">
        <div className="title_bar d-flex align-items-center justify-content-between">
          <div className="text-style">Professional Service Users</div>

          <div className="d-flex">
            {getCombinedListing.data && (
              <>
                <button
                  className="btn btn-transparant mx-2"
                  onClick={handleCsvDownload}
                >
                  Export CSV
                </button>
                <CSVLink
                  data={csvData}
                  filename="Attorney-list"
                  ref={csvLink}
                  headers={headers}
                />
              </>
            )}
            <button
              className="btn btn-thm"
              onClick={(e) => {
                e.preventDefault();
                setShowPopup(true);
              }}
            >
              Add Professional Service User
            </button>
          </div>
        </div>

        <div className="conten-div">
          <div className="d-flex justify-content-between">
            <div className="flex-1">
              <SearchBox handleSearch={handleSearch} search={search} />
            </div>
          </div>
          <div className="d-flex mt-4">
            {_.map(tabs, (tab, tabIndex) => (
              <div // NOSONAR
                onClick={(e) => {
                  e.preventDefault();
                  setLoading(true);
                  setTimeout(() => {
                    setLoading(false);
                  }, 1000);
                  setActiveTab(tabIndex);
                  setSearch("");
                }}
                className={`tab-link ${activeTab === tabIndex ? "active" : ""}`}
                key={`${tab}-${tabIndex}-attonery`}
              >
                {tab}
              </div>
            ))}
          </div>
          <div className="TableData mt-4">
            {activeTab === 0 && <ActiveAttorney filteredData={filteredData} />}
            {activeTab === 1 && (
              <ArchivedAttorney filteredData={filteredData} />
            )}
          </div>
        </div>
      </div>
      <ModalCustom size="xs" handleClose="grantorModal" show={showPopup}>
        <AddAttorney setShowAttornyPopup={setShowPopup} />
      </ModalCustom>
    </>
  );
};

export default Attorney;
